export type AllowedMimeTypes = "image/jpeg" | "image/png" | "video/mp4" | "application/pdf";
export type FileType = "IMAGE" | "VIDEO" | "PDF";

export const ALLOWED_FILE_TYPES = new Set<AllowedMimeTypes>([
	"image/jpeg",
	"image/png",
	"video/mp4",
	"application/pdf",
]);

export const getFileType = (mime: AllowedMimeTypes): FileType => {
	if (mime === "image/jpeg" || mime === "image/png") {
		return "IMAGE";
	}
	if (mime === "video/mp4") {
		return "VIDEO";
	}
	return "PDF";
};

export type DicomizeStatus =
		"IDLE"
		| "STARTED_PROCESSING"
		| "DICOMIZING"
		| "STORING"
		| "ABORTED"
		| "SUCCESS"
		| "FAILED"
		| ClientDicomizeStatus;
type ClientDicomizeStatus = "SENDING" | "ABORTING";

export interface DicomizeProgress {
	status: DicomizeStatus;
	total: number;
	dicomized: number;
	sent: number;
}